import styled from "@emotion/styled";
import { COLOR_SECONDARY, COLOR_LINK, FONT_SIZE_SMALL } from "../theme";

interface LinkProps {
  underline?: boolean;
  color?: string;
  linkColor?: string;
}

const Link = styled.a<LinkProps>`
  color: ${(props) => props.color ?? { COLOR_SECONDARY }};
  text-decoration: ${(props) => (props.underline ? "underline" : "none")};
  cursor: pointer;
  &:hover {
    text-decoration: underline;
    color: ${COLOR_LINK};
    text-decoration-color: ${(props) => props.linkColor ?? COLOR_LINK};
  }
`;

export const LinkSmall = styled(Link)`
  font-size: ${FONT_SIZE_SMALL};
`;

export const A = styled.a`
  text-decoration: none;
`;

export const ExternalLink = styled(A)`
  &:hover {
    text-decoration: none;
  }
`;

export default Link;
